import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from "recharts";
import { DOMAINS } from "@/lib/framework";

// growth: [{ term, tsb, domains: {execution, cognitive, growth} }]
export function GrowthChart({ growth, height = 300, showDomains = true, testId }) {
  const data = growth.map((g) => ({
    term: g.term,
    TSB: g.tsb,
    ...(g.domains || {}),
  }));
  return (
    <div style={{ width: "100%", height }} data-testid={testId}>
      <ResponsiveContainer>
        <LineChart data={data} margin={{ top: 10, right: 16, left: -10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eef2f6" vertical={false} />
          <XAxis dataKey="term" tick={{ fontSize: 12, fill: "#475569" }} />
          <YAxis domain={[1, 4]} tick={{ fontSize: 11, fill: "#94a3b8" }} />
          <Tooltip formatter={(v) => Number(v).toFixed(2)} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Line type="monotone" dataKey="TSB" stroke="#003057" strokeWidth={3} dot={{ r: 4 }} activeDot={{ r: 6 }} />
          {showDomains &&
            DOMAINS.map((d) => (
              <Line key={d.id} type="monotone" dataKey={d.id} name={d.short}
                stroke={d.color} strokeWidth={2} strokeDasharray="4 3" dot={{ r: 3 }} />
            ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
